import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import CommonKpisBox from "../../../components/CommonKpisBox";
import CallTable from "./CallTable";
import axiosInstance from "../../../services/axiosInterceptors";
import apiEndPointsConfig from "../../../services/apiEndPoints";
import { formatDuration } from "../../../utils/common";
import Loader from "../../../components/AnimatedLoader";
import CommonFilter from "../../../components/CommonFilter";
import { palette, theme as colorTheme} from "../../../Convoze.theme";
import ParentWrapper from "../../../components/ParentWrapper";
import Header from "../../../components/header";

const primary = colorTheme('palette', 'primary').value;
const pop = colorTheme('palette', 'pop').value;
const positive = colorTheme('palette', 'positive').value;
const neutral = colorTheme('palette', 'neutral').value;
const negative = colorTheme('palette', 'negative').value;


function MyCalls() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [myCallsData, setMyCallsData] = useState();
  const [loading, setLoading] = useState(true);
  const [payloadData, setPayloadData] = useState();

  const cardsData = [
    {
      title: "Total Calls ",
      value: myCallsData?.dashboardMatrics?.totalCallRecordings || "0",
      icon: "PhoneIcon",
      iconBgColor: "#DBEAFE",
      iconColor: primary,
      trend: {
        direction:
          myCallsData?.trendMetrics?.callVolumeTrend?.direction == "decrease"
            ? "down"
            : myCallsData?.trendMetrics?.callVolumeTrend?.direction ==
              "increase"
            ? "up"
            : "no change",
        value: myCallsData?.trendMetrics?.callVolumeTrend?.percent || "0",
        note: "vs Last period",
      },
    },
    {
      title: "Average Call Duration",
      value: formatDuration(myCallsData?.dashboardMatrics?.averageCallDuration),
      icon: "AccessTimeIcon",
      iconBgColor: "#F3E8FF",
      iconColor: pop,
      trend: {
        direction:
          myCallsData?.trendMetrics?.averageCallDurationTrend?.direction ==
          "decrease"
            ? "down"
            : myCallsData?.trendMetrics?.averageCallDurationTrend?.direction ==
              "increase"
            ? "up"
            : "no change",
        value:
          myCallsData?.trendMetrics?.averageCallDurationTrend?.percent || 0,
        note: "vs Last period",
      },
    },
    {
      title: "Overall Sentiment Score",
      value: myCallsData?.dashboardMatrics?.avgSentimentScore
        ? `${myCallsData?.dashboardMatrics?.avgSentimentScore.toFixed(1)}%`
        : "0",
      icon: "SentimentSatisfiedAlt",
      iconBgColor: "#DCFCE7",
      iconColor: positive,
      trend: {
        direction:
          myCallsData?.trendMetrics?.sentimentScoreTrend?.direction ==
          "decrease"
            ? "down"
            : myCallsData?.trendMetrics?.sentimentScoreTrend?.direction ==
              "increase"
            ? "up"
            : "no change",
        value: myCallsData?.trendMetrics?.sentimentScoreTrend?.percent || 0,
        note: "vs Last period",
      },
    },
  ];
  const token = localStorage.getItem("token") || "";

  useEffect(() => {
    fetchMyCallsDetails();
  }, [payloadData]);

  const fetchMyCallsDetails = async () => {
    const today = new Date();
    const data = {
      startDate: payloadData?.filters?.startDate
        ? payloadData?.filters?.startDate
        : today?.toISOString().split("T")[0],
      endDate: payloadData?.filters?.endDate
        ? payloadData?.filters?.endDate
        : today?.toISOString().split("T")[0],
    };
    try {
      const res = await axiosInstance.post(
        apiEndPointsConfig?.agentMyCalls,
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setMyCallsData(res?.data?.data);
      setLoading(false);
    } catch (error) {
      const statusCode = error?.response?.data?.status?.code;
      if (statusCode) {
        if (statusCode === 401) {
          localStorage.clear();
        }
      } else {
        console.error("No error code received from the server");
      }
    }
  };

  const isFilter = { date: true, filter: false };

  return (
    // <Box
    //   sx={{
    //      ml: {
    //       xs: "0px",
    //       md: "230px",
    //     },
    //     p: 3,
    //     display: "flex",
    //     flexDirection: "column",
    //     gap: 2,
    //   }}
    // >
    //   {loading ? (
    //     <Loader />
    //   ) : (
    //     <Grid container spacing={2.5} sx={{}}>
    //       <Grid item size={{ xs: 12 }} sx={{}}>
    //         <Box
    //           sx={{
    //             display: "flex",
    //             justifyContent: "space-between",
    //             alignItems: "flex-start",
    //             flexDirection: isMobile ? "column" : "row",
    //             mb: 3,
    //           }}
    //         >
    //           <Box>
    //             <Typography
    //               variant="h5"
    //               sx={{
    //                 fontFamily:
    //                   "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
    //                 fontWeight: 700,
    //               }}
    //               gutterBottom
    //             >
    //               My Calls
    //             </Typography>
    //             <Typography variant="subtitle1" color="text.secondary">
    //               Review and analyze your call recordings
    //             </Typography>
    //           </Box>

    //           <Box sx={{ alignItems: "flex-end" }}>
    //             <CommonFilter
    //               setPayloadData={setPayloadData}
    //               storageName={"AgentMyCalls"}
    //               isFilter={isFilter}
    //               setLoading={setLoading}
    //             />
    //           </Box>
    //         </Box>
    //       </Grid>
    //       <CommonKpisBox cardsData={cardsData} cardLength={4} />
    //       <Grid item size={{ xs: 12 }} sx={{}}>
    //         <CallTable myCallsData={myCallsData?.callRecordings} />
    //       </Grid>
    //     </Grid>
    //   )}


    // </Box>

    <ParentWrapper>

        {loading ? (
        <Loader />
      ) : (
        <Grid container spacing={2.5} sx={{}}>
          <Grid item size={{ xs: 12 }} sx={{}}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "flex-start",
                flexDirection: isMobile ? "column" : "row",
                mb: 3,
              }}
            >
              <Box>
                {/* <Typography
                  variant="h5"
                  sx={{
                    fontFamily:
                      "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
                    fontWeight: 700,
                  }}
                  gutterBottom
                >
                  My Calls
                </Typography>
                <Typography variant="subtitle1" color="text.secondary">
                  Review and analyze your call recordings
                </Typography> */}
                 {/* <Header title={"My Calls"} subHeading={"Review and analyze your call recordings"} /> */}
              </Box>

              <Box sx={{ alignItems: "flex-end" }}>
                <CommonFilter
                  setPayloadData={setPayloadData}
                  storageName={"AgentMyCalls"}
                  isFilter={isFilter}
                  setLoading={setLoading}
                />
              </Box>
            </Box>
          </Grid>
          <CommonKpisBox cardsData={cardsData} cardLength={4} />
          <Grid item size={{ xs: 12 }} sx={{}}>
            <CallTable myCallsData={myCallsData?.callRecordings} />
          </Grid>
        </Grid>
      )}
    </ParentWrapper>
  );
}

export default MyCalls;
